var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bootscreen-div" },
    [
      _c("div", { staticClass: "bootscreen-top" }, [
        _vm.headerLogo && _vm.headerLogo.length > 0
          ? _c("img", {
              staticClass: "bootscreen-top-logo",
              attrs: { src: _vm._f("imgFormat")(_vm.headerLogo), alt: "" },
            })
          : _c("div", { staticClass: "bootscreen-top-logo" }),
        _c("div", { staticClass: "bootscreen-top-timediv" }, [
          _c("div", { staticClass: "timediv-clock" }, [
            _vm._v(_vm._s(_vm.timeString)),
          ]),
          _c("div", { staticClass: "timediv-date" }, [
            _vm._v(_vm._s(_vm.dateString)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bootscreen-middle" }, [
        _vm.hasLogo
          ? _c("img", {
              staticClass: "bootscreen-middle-logo",
              attrs: {
                src: require("../../../public/img/product/bootScreen/img-left.png"),
                alt: "",
              },
            })
          : _vm._e(),
        _c("div", { staticClass: "bootscreen-middle-content" }, [
          _c("div", { staticClass: "content-header" }),
          _c("div", { staticClass: "content-main" }, [_c("router-view")], 1),
        ]),
      ]),
      _vm.hiddenTab
        ? _c(
            "div",
            {
              staticClass: "bootscreen-hotline",
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _c("div", { staticClass: "iconfont icon-icon-back" }),
              _c("div", { staticClass: "bootscreen-hotline-text" }, [
                _vm._v("返回"),
              ]),
            ]
          )
        : _c(
            "div",
            { staticClass: "bootscreen-bottom" },
            _vm._l(_vm.bottomButtonArr, function (item, index) {
              return _c(
                "div",
                {
                  key: "bootscreen-bottom-item" + index,
                  staticClass: "bootscreen-bottom-item",
                  class:
                    index == _vm.selectIndex
                      ? "bootscreen-bottom-item-selected"
                      : "",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "button-content",
                      on: {
                        click: function ($event) {
                          return _vm.selectTabButton(index)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "button-logo",
                        attrs: { src: _vm.bottomImageIcon[index], alt: "" },
                      }),
                      _c("div", { staticClass: "button-text" }, [
                        _vm._v(_vm._s(item)),
                      ]),
                    ]
                  ),
                  _c("img", {
                    staticClass: "button-shadow",
                    attrs: {
                      src: require("../../../public/img/product/bootScreen/btn-shadow.png"),
                      alt: "",
                    },
                  }),
                ]
              )
            }),
            0
          ),
      _c(
        "van-dialog",
        {
          staticClass: "bootscreensignin-dialog",
          attrs: {
            "show-confirm-button": false,
            "show-cancel-button": false,
            "close-on-click-overlay": true,
            "get-container": "#app",
          },
          model: {
            value: _vm.showMistakeAddressDialog,
            callback: function ($$v) {
              _vm.showMistakeAddressDialog = $$v
            },
            expression: "showMistakeAddressDialog",
          },
        },
        [
          _c("div", { staticClass: "dialog-maindiv" }, [
            _c("div", { staticClass: "dialog-closebuttondiv" }, [
              _c("div", { staticClass: "dialog-closenotice" }, [
                _vm._v("点击任意阴影处关闭"),
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-closebutton",
                  on: {
                    click: function ($event) {
                      _vm.showMistakeAddressDialog = false
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-icon_wrong" })]
              ),
            ]),
            _c(
              "div",
              { staticClass: "dialog-maininfo" },
              [
                _c("mistake-sign-in-address", {
                  attrs: {
                    attendInfo: _vm.attendInfo,
                    addressInfo: _vm.addressInfo,
                    currentPlace: _vm.currentAddress,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }